export const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp', 'bmp', 'svg']);
export const VIDEO_EXTENSIONS = new Set(['mp4', 'avi', 'mkv', 'mov', 'wmv']);
export const EXTENSION_ONLY_VIDEO_EXTENSIONS = new Set(['mp4']);
